import { Box, ButtonBase, Drawer, IconButton, styled, Typography } from "@mui/material";

const MobileDrawer = styled(Drawer)({
  "& .MuiDrawer-paper": {
    width: "min(82vw, 288px)",
    boxSizing: "border-box",
    padding: "18px 16px 24px",
    border: 0,
    borderRadius: "0 16px 16px 0",
    boxShadow: "12px 0 32px rgba(22, 28, 40, 0.16)",
  },
});

const CloseMenuButton = styled(IconButton)({
  color: "#50A7EA",
  flex: "0 0 40px",
  width: 40,
  height: 40,
  marginLeft: "auto",
});

const DrawerContent = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  minHeight: 48,
  width: "100%",
  gap: 8,
  "& > div:first-of-type": {
    minWidth: 0,
  },
}));

const MobileMenuNav = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 8,
  marginTop: 24,
  paddingTop: 16,
  borderTop: "1px solid #E8EDF2",
});

const MobileMenuItem = styled(ButtonBase)({
  display: "flex",
  alignItems: "center",
  width: "100%",
  minHeight: 52,
  padding: "0 14px",
  borderRadius: 8,
  color: "#344054",
  fontSize: 15,
  fontWeight: 700,
  textAlign: "left",
  transition: "background-color 160ms ease, color 160ms ease",
  "& svg": {
    flex: "0 0 auto",
    width: 21,
    height: 21,
    marginRight: 12,
  },
  "& .menu-arrow": {
    width: 18,
    height: 18,
    marginRight: 0,
    marginLeft: "auto",
    opacity: 0.45,
  },
  "&:hover": {
    backgroundColor: "#F2F7FA",
  },
  '&[aria-current="page"]': {
    color: "#087DBD",
    backgroundColor: "#EAF6FC",
  },
});

const StyledGithubIcon = styled("img")({
  height: "100%",
  objectFit: "contain",
  padding: 0,
});

const AppMenu = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 11,
  height: 35,
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    width: "calc(100vw - 60px)",
    maxWidth: 400,
    padding: "40px 30px 40px 30px",
    gap: 20,
    height: "unset",
    "& .connected-section": {
      order: 1,
      width: "100%",
      maxWidth: "unset",
      height: 35,
      marginTop: 40,
      "& p": {
        maxWidth: "unset",
      },
    },
    "& .github-icon": {
      order: 4,
      marginTop: 40,
    },
    "& .custom-link": {
      order: 3,
      width: "100%",
      height: 35,
      "& .base-button": {
        width: "100%",
      },
    },
  },
}));

const HeaderTypography = styled(Typography)(({ theme }) => ({
  color: "#000",
  fontWeight: 700,
  fontSize: 18,
  marginLeft: theme.spacing(1),
}));

export {
  MobileDrawer,
  CloseMenuButton,
  DrawerContent,
  MobileMenuNav,
  MobileMenuItem,
  AppMenu,
  HeaderTypography,
  StyledGithubIcon,
};
